export default __webpack_public_path__ + "static/media/medium.735970ec.woff2";